module.exports = __webpack_public_path__ + "static/media/Picture5.835821e6.png";